// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__LRwsm","formControl":"addForm_formControl__Em5N1","list":"addForm_list__DDrnF","btnWrpper":"addForm_btnWrpper__WgoCV"};